import Image, { type ImageProps } from 'next/image';

// The default next.js Image component only skips optimization for SVG automatically
// based on their extension. This was broken using ImageX domains because ImageX
// doesn't use proper extension; Adding custom logic to handle SVGs properly
// https://github.com/vercel/next.js/blob/2072f864fc1d716d0884628dada7e1c6fbf7fbf2/packages/next/src/shared/lib/get-img-props.ts#L389
const CustomNextImage: React.FC<ImageProps> = ({ src, alt, ...rest }) => {
  const isSvg =
    typeof src === 'string' &&
    (src.endsWith('.svg') || src.includes('.svg~' /* ImageX concatenation rule */));

  return <Image alt={alt} src={src} unoptimized={isSvg} {...rest} />;
};

export { CustomNextImage as Image };
